import { RouteInfo } from './sidebar.metadata';
import { CHEMICAL_ROUTES_LIST } from './chemical-menu';

export const CHEMICALCHROUTES: RouteInfo[] = CHEMICAL_ROUTES_LIST;
